import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../Datas/siteConfig";
import "../css/delivery.scss";

export const POLICY_UPDATED_ISO = "2026-10-17";
export const POLICY_UPDATED_LABEL = "17 October 2026";

function PolicyDocument({
  eyebrow = "Store policy",
  title,
  intro,
  highlights,
  sections,
  helpLabel = "Need help?",
  helpText = "Contact customer care",
  className = "",
}) {
  return (
    <main className={`policy-page ${className}`.trim()} id="main-content">
      <header className="policy-page__header">
        <p className="policy-page__eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{intro}</p>
        <p className="policy-page__updated">
          Last updated{" "}
          <time dateTime={POLICY_UPDATED_ISO}>{POLICY_UPDATED_LABEL}</time>
        </p>
      </header>

      {highlights?.length > 0 && (
        <dl className="policy-page__summary" aria-label={`${title} at a glance`}>
          {highlights.map((item) => (
            <div key={item.label}>
              <dt>{item.label}</dt>
              <dd>{item.value}</dd>
            </div>
          ))}
        </dl>
      )}

      <div className="policy-page__layout">
        <aside className="policy-page__aside" aria-label="On this page">
          <p>On this page</p>
          <ol>
            {sections.map((section) => (
              <li key={section.id}>
                <a href={`#${section.id}`}>{section.title}</a>
              </li>
            ))}
          </ol>
          <div className="policy-page__help">
            <span>{helpLabel}</span>
            <Link to="/contact">{helpText}</Link>
          </div>
        </aside>

        <article className="policy-page__content">
          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <span className="policy-page__number" aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h2>{section.title}</h2>
                {section.body?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {section.bullets?.length > 0 && (
                  <ul>
                    {section.bullets.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                {section.route && (
                  <Link className="policy-page__inline-link" to={section.route}>
                    {section.routeLabel}
                  </Link>
                )}
                {section.contact && (
                  <p>
                    Email{" "}
                    <a href={`mailto:${siteConfig.contact.customerServiceEmail}`}>
                      {siteConfig.contact.customerServiceEmail}
                    </a>
                    {section.contactSuffix || "."}
                  </p>
                )}
              </div>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}

export default PolicyDocument;
